// planetDescriptor.js
var PlanetDescriptor = pc.createScript('planetDescriptor');

// initialize code called once per entity
PlanetDescriptor.prototype.initialize = function() {
 //   this.app.on('civCounter', this.civCounter, this);
 //   this.app.on('stellar', this.stellar, this);
  //  this.app.on('interStellar', this.interStellar, this);
  //  this.app.on('systemGenerator:reset', this.resetMe, this);
    this.civilizations = 0;
    this.stlr = false;
    this.intrStlr = false;
};

PlanetDescriptor.prototype.civCounter = function(){
    this.civilizations += 1;
};

PlanetDescriptor.prototype.stellar = function(){
    this.stlr = true;
};

PlanetDescriptor.prototype.interStellar = function(){
    this.intrStlr = true;
};

PlanetDescriptor.prototype.resetMe = function(){
    this.civilizations = 0;
    this.stlr = false;
    this.intrStlr = false;
};

// update code called every frame
PlanetDescriptor.prototype.update = function(dt) {
   // console.log('civs: ' + this.civilizations + ' ' + 'stellar: ' + this.stlr + ' ' + 'interst.: ' + this.intrStlr);
};

// swap method called for script hot-reloading
// inherit your script state here
// PlanetDescriptor.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

